import React from 'react';
import Box from '../../components/Box/Box';
import Regular from '../../components/Text/Regular';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { TListBase } from './types';

const ListBase = ({ as, kind, title, children, ...rest }: TListBase) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind,
  });
  return (
    <Box {...conditionalProps} as={as} name="List" {...rest}>
      {title && <Regular color="TextTertiary">{title}</Regular>}
      {children}
    </Box>
  );
};

export default ListBase;
